import React from 'react'

function ArrowDownIcon() {
  return (
    <svg
      width="14"
      height="7"
      viewBox="0 0 14 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7071 0.256282C14.0976 0.59799 14.0976 1.15201 13.7071 1.49372L7.70711 6.74372C7.31658 7.08543 6.68342 7.08543 6.29289 6.74372L0.292893 1.49372C-0.0976315 1.15201 -0.0976315 0.59799 0.292893 0.256281C0.683416 -0.0854277 1.31658 -0.0854277 1.70711 0.256281L7 4.88756L12.2929 0.256282C12.6834 -0.0854272 13.3166 -0.0854272 13.7071 0.256282Z"
        fill="black"
        fillOpacity="0.5"
      />
    </svg>
  )
}

export default ArrowDownIcon
